import { Component, EventEmitter, Input, OnInit, Output, TemplateRef, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Subject, takeUntil } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { InterestedPerson } from 'src/app/models/common-models';
import { EnvironmentService } from 'src/app/services/environment.service';
import { InterestedPersonService } from 'src/app/services/interested-person.service';
import { FacilityConfig } from 'src/environments/environment.interface';

@Component({
  selector: 'df-presale-book',
  templateUrl: './df-presale-book.component.html',
  styleUrls: ['./df-presale-book.component.scss']
})
export class PresaleBookComponent implements OnInit {
  @Input()
  modal: any;

  @Input()
  title: string = 'Presale Booking';

  @Output() booked: EventEmitter<boolean> = new EventEmitter();

  @ViewChild('presaleBook', { read: TemplateRef }) presaleBook: TemplateRef<any> | undefined;

  private readonly _unsubscribe: Subject<any> = new Subject();
  facilityConfig: FacilityConfig = {} as FacilityConfig;
  appStoreUrl: string = '';
  playStoreUrl: string = '';
  session: any = null;
  prospectInfo: any = null;
  bookingSuccessful: boolean = false;
  errorMessage: string = '';
  constructor(
    private modalService: NgbModal,
    private _environmentService: EnvironmentService,
    private interestedPersonService: InterestedPersonService,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.facilityConfig = this._environmentService.getFacilityConfig();
    this.appStoreUrl = this._environmentService.getLinkUrlById('appStore');
    this.playStoreUrl = this._environmentService.getLinkUrlById('playStore');
  }

  public open(session: any, prospectInfo: any): void {
    this.session = session;
    this.prospectInfo = prospectInfo;
    this.bookingSuccessful = false; // Reset state when opening
    this.errorMessage = ''; // Reset error message when opening
    this.openModal(this.presaleBook);
  }

  public dismiss() {
    this.modalService.dismissAll();

    // If booking was successful, clear sessionStorage and redirect to root
    if (this.bookingSuccessful) {
      sessionStorage.removeItem('prospectInfo');
      this.router.navigate(['/']);
    }
  }

  public book() {
    this.errorMessage = ''; // Reset error message
    this.interestedPersonService.bookInterestedPerson(this.session.Id, this.prospectInfo.Id)
      .pipe(
        takeUntil(this._unsubscribe),
        catchError((error: any) => {
          this.errorMessage = error.error?.message || error.error?.ExceptionMessage || error.message || 'An error occurred while booking. Please try again.';
          throw error;
        })
      )
      .subscribe((data: InterestedPerson) => {
        this.bookingSuccessful = true;
        this.booked.emit(true);
      });
  }

  public openModal(modal: any): void {
    let modalRef = this.modalService.open(modal, {
      ariaLabelledBy: 'modal-basic-title',
      centered: true,
      fullscreen: window.innerWidth <= 768,
      backdrop: 'static',
      keyboard: false
    });
  }
}
